var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUploadAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2H13.25V8C13.25 8.9665 14.0335 9.75 15 9.75H20.9992C20.9997 9.76904 21 9.78811 21 9.80721V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V4C3 2.89543 3.89543 2 5 2ZM12.5303 9.96965C12.3896 9.829 12.1989 9.74999 12 9.75C11.8011 9.75001 11.6103 9.82903 11.4696 9.96969L8.96987 12.4697C8.67699 12.7626 8.67701 13.2375 8.96992 13.5304C9.26282 13.8232 9.7377 13.8232 10.0306 13.5303L11.25 12.3108V16.5C11.25 16.9142 11.5858 17.25 12 17.25C12.4142 17.25 12.75 16.9142 12.75 16.5V12.3105L13.9699 13.5304C14.2628 13.8232 14.7377 13.8232 15.0306 13.5303C15.3235 13.2374 15.3234 12.7625 15.0305 12.4696L12.5303 9.96965ZM6.75 16C6.75 15.5858 6.41421 15.25 6 15.25C5.58579 15.25 5.25 15.5858 5.25 16V18C5.25 18.9665 6.0335 19.75 7 19.75H17C17.9665 19.75 18.75 18.9665 18.75 18V16C18.75 15.5858 18.4142 15.25 18 15.25C17.5858 15.25 17.25 15.5858 17.25 16V18C17.25 18.1381 17.1381 18.25 17 18.25H7C6.86193 18.25 6.75 18.1381 6.75 18V16Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8399 2.61172L20.2768 8.24999H15C14.8619 8.24999 14.75 8.13806 14.75 7.99999V2.52417C14.7808 2.55232 14.8108 2.58151 14.8399 2.61172Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUploadAlt);
export default __webpack_public_path__ + "static/media/file-upload-alt.32e209d66ab0ca851d280ae9e1df063c.svg";
export { ForwardRef as ReactComponent };